// UI 문구 리터럴 전부. 템플릿 변수에는 pricing·플롯·서버 값만 끼운다.
const ko = {
  "app.name": "hamlak",
  "ota.updating": "새 버전으로 업데이트하고 있어요",
  "home.title": "홈",
  "home.empty": "아직 플롯이 없어요",
  "home.loadError": "플롯을 불러오지 못했어요",
  // 홈 사업자 정보 푸터(AC0-230). 값은 config/company
  "home.footer.copyright": "© {company}",
  "home.footer.ceo": "대표자: {name}",
  "home.footer.bizRegNo": "사업자등록번호: {no}",
  "home.footer.mailOrderNo": "통신판매업신고번호: {no}",
  "home.footer.csPhone": "고객센터: {phone}",
  "home.footer.email": "이메일: {email}",
  "home.footer.links": "약관 및 정책",
  "home.footer.terms": "이용약관",
  "home.footer.refundPolicy": "환불정책",
  "home.footer.operationPolicy": "운영정책",
  "home.footer.privacy": "개인정보처리방침",
  "home.footer.youthPolicy": "청소년 보호정책",
  "nav.home": "홈",
  "nav.chats": "대화",
  "nav.me": "마이페이지",

  "plot.conversations": "대화 {count}",
  "plot.intro": "소개",
  "plot.firstScene": "인트로",
  "plot.character": "캐릭터",
  "plot.age": "{age}세",
  "plot.creator": "크리에이터",
  "plot.cta": "대화 시작하기",
  "plot.inactive": "지금은 대화할 수 없는 캐릭터예요",
  "feedback.title": "hamlak, 써 보니 어떠셨어요?",
  "feedback.description": "보내 주신 의견으로 더 열심히 만들게요",
  "conversations.empty.title": "아직 허물 철벽이 없어요",
  "conversations.empty.body": "마음에 드는 캐릭터를 골라 첫 대화를 시작해 보세요.",
  "conversations.empty.cta": "캐릭터 둘러보기",
  "conversations.loadError": "대화 목록을 불러오지 못했어요",
  "conversations.unavailable": "지금은 대화할 수 없는 캐릭터예요",
  "conversations.unavailableTap": "이 캐릭터는 지금 만날 수 없어요. 대화 기록은 그대로 남아 있어요",
  "conversations.more": "{name} 대화 메뉴",
  "leave.title": "대화방을 나갈까요?",
  "leave.body": "대화 목록에서 사라지고, 대화 내용은 복구할 수 없어요.",
  "leave.bodyInactive": "이 캐릭터와는 다시 대화할 수 없어요.",
  "leave.confirm": "나가기",
  "leave.done": "대화방을 나갔어요",
  "time.justNow": "방금",
  "time.yesterday": "어제",
  "plot.notFound": "플롯을 찾을 수 없어요",
  "plot.menu.report": "신고하기",
  "plot.menu.share": "공유하기",
  "plot.share.copied": "링크를 복사했어요",
  "plot.share.failed": "공유하지 못했어요",

  "chat.aiNotice": "ⓘ 답변은 모두 AI가 생성한 내용이에요",
  "chat.placeholder": "메시지 입력…  *행동*은 별표로",
  "chat.suggest": "추천 답변 받기 · {cost}브릭",
  "chat.copied": "메시지를 복사했어요",
  "chat.copy": "복사",
  "chat.copyFailed": "복사하지 못했어요",
  "chat.loadError": "대화를 불러오지 못했어요",
  "chat.model.title": "대화 모델",
  "chat.model.description": "다음 메시지부터 적용돼요.\n기억은 어떤 모델이든 그대로 이어져요.",
  "chat.model.default": "기본",
  "chat.model.apply": "변경",
  "chat.model.continue": "이 모델로 계속하기",
  "chat.model.unavailable": "지금은 이 모델을 쓸 수 없어요. 이전 모델로 계속해요.",
  "chat.model.saveFailed": "모델을 바꾸지 못했어요. 이전 모델로 계속해요.",
  "chat.tools.hidePresets": "대화 프리셋 숨기기",
  "chat.menu.model": "대화 모델 변경",
  "chat.menu.plot": "플롯 프로필 보기",
  "chat.menu.feedback": "의견 보내기",
  "chat.menu.report": "신고하기",
  "chat.menu.leave": "대화방 나가기",
  "chat.suggest.failed": "추천 답변을 가져오지 못했어요",
  "chat.settings.failed": "설정을 저장하지 못했어요",

  "turn.error.title": "답장을 불러오지 못했어요",
  "turn.error.refunded": "차감된 {refunded}브릭은 바로 돌려드렸어요.",
  "turn.error.generic": "잠시 후 다시 시도해 주세요.",
  // F03-05(79:2086): 생성 실패류는 시안 한 문장으로. 필터·연결 오류(generic)는 뜻이 달라 따로
  "turn.error.LLM_FAILED": "응답을 만들지 못했어요.",
  "turn.error.LLM_TIMEOUT": "응답을 만들지 못했어요.",
  "turn.error.CONTENT_FILTERED": "이 내용으로는 답장을 만들 수 없어요. 다른 말로 이어가 주세요.",
  "turn.error.INTERNAL": "응답을 만들지 못했어요.",
  "turn.retry": "다시 시도",
  "turn.rewrite": "다른 말로 이어가기",
  "turn.inProgress": "아직 답장을 만들고 있어요. 잠시만 기다려 주세요.",
  "turn.rateLimited": "요청이 너무 잦아요. 잠시 후 다시 보내 주세요.",
  "turn.modelUnavailable": "지금은 이 모델을 쓸 수 없어요. 다른 모델을 골라 주세요.",
  "turn.recovering": "연결을 복구하는 중…",
  "turn.thinking": "{name}{josa} 답장을 고민하는 중…",
  "reroll.action": "다시 생성",
  "reroll.title": "답변 다시 생성",
  "reroll.description": "원하는 방향을 적으면 반영해서 다시 써요. 비워 두어도 돼요.",
  "reroll.direction": "원하는 방향 (선택)",
  "reroll.direction.placeholder": "예: 더 다정하게 / 대사는 짧게 / 질투하는 반응으로",
  "reroll.cta": "다시 생성",
  "reroll.cost": "{cost}브릭",
  "reroll.thinking": "{name}{josa} 다른 답장을 고민하는 중…",
  "reroll.error.title": "다시 생성하지 못했어요",
  "reroll.error.kept": "기존 답변은 그대로 두었어요.",
  "reroll.notLatest": "마지막 답변만 다시 생성할 수 있어요.",

  "insufficient.title": "브릭이 부족해요",
  "insufficient.description": "대화를 이어가려면 브릭이 필요해요.",
  "insufficient.required": "필요한 브릭",
  "insufficient.balance": "보유 브릭",
  "insufficient.cta": "브릭 충전하기",
  "insufficient.firstPurchase.lead": "첫 결제는 ",
  "insufficient.firstPurchase.allRate": "모든 상품 {percent}% 할인이에요",
  "insufficient.firstPurchase.other": "할인된 가격으로 살 수 있어요",
  "insufficient.continueWith": "{model}로 계속하기",

  // {plot} 뒤 조사는 withJosa()로 와/과 분기(시안 F01-13 "김흰과")
  "login.consent": "가입 시 서비스 이용약관 및 개인정보 처리방침에 동의하게 돼요.",
  "login.cta": "그 철벽, 당신이 허물어 볼래요?",
  "login.gift": "가입하면 가입 선물 {amount}브릭을 드려요",
  "login.google": "Google로 시작하기",
  "login.apple": "Apple로 시작하기",
  "login.provider.google": "Google",
  "login.provider.apple": "Apple",
  // F01-10(122:6824) 로그인 실패 다이얼로그. 취소는 띄우지 않는다
  "login.failed.title": "로그인하지 못했어요",
  "login.failed.body": "로그인이 취소되었거나 연결이 불안정해요.\n잠시 후 다시 시도해 주세요.",
  "login.unavailable": "지금은 {provider} 로그인을 쓸 수 없어요. 잠시 후 다시 시도해 주세요.",
  "onboarding.abandoned": "가입을 마치지 않아 로그아웃했어요",
  "login.rejoinBlocked": "탈퇴 후 {days}일 동안은 다시 가입할 수 없어요",
  "login.rejoinBlocked.until": "{until} 이후에 다시 가입할 수 있어요",
  "login.openInBrowser.title": "외부 브라우저에서 열어 주세요",
  "login.openInBrowser": "이 브라우저에서는 Google·Apple 로그인을 할 수 없어요. 외부 브라우저에서 열어 주세요.",
  "settings.account": "로그인 계정",
  // 로그인 계정 값(시안 F07-05 "구글"). login.provider.google 은 로그인 실패 문구용이라 따로 둔다. Apple 은 시안 없음 → login.provider.apple
  "settings.account.google": "구글",
  "login.openInBrowser.cta": "외부 브라우저에서 열기",
  "login.openInBrowser.copied": "주소를 복사했어요. Safari에 붙여 넣어 열어 주세요.",

  "terms.title": "함락을 시작하기 전에\n약관에 동의해 주세요",
  "terms.all": "전체 동의",
  "terms.tos": "서비스 이용약관",
  "terms.privacy": "개인정보 수집 및 이용",
  "terms.ai": "AI 생성 콘텐츠 이용 안내",
  "terms.marketing": "마케팅 정보 수신 (앱 푸시)",
  "terms.nightMarketing": "야간 혜택 알림 수신 (21시~08시)",
  "terms.required": "[필수]",
  "terms.optional": "[선택]",
  "terms.view": "{name} 보기",
  "terms.cta": "동의하고 계속하기",

  "birthDate.title": "생년월일을 알려 주세요",
  "birthDate.description": "만 14세 이상만 함락을 이용할 수 있어요.\n생년월일은 나이 확인에만 쓰고, 다른 사람에게 보이지 않아요.",
  "birthDate.label": "생년월일",
  "birthDate.example": "예) 2001년 5월 14일 → 2001 / 05 / 14",
  "birthDate.year": "연도",
  "birthDate.month": "월",
  "birthDate.day": "일",
  "birthDate.invalid": "올바른 날짜를 입력해 주세요",
  "birthDate.cta": "확인",
  "underAge.title": "가입할 수 없어요",
  "underAge.body": "함락은 만 14세 이상만 이용할 수 있어요. 입력한 생년월일은 저장하지 않고 바로 삭제했어요.",
  "underAge.cta": "확인",

  "profile.title": "프로필 만들기",
  "profile.me.title": "대화 속 나",
  "profile.me.description": "캐릭터가 나를 이렇게 기억해요",
  "profile.name": "이름",
  "profile.name.description": "캐릭터가 날 이렇게 불러요",
  "profile.name.placeholder": "이름을 입력해주세요",
  "profile.name.required": "이름을 입력해주세요",
  "profile.bio": "설명 (선택)",
  "profile.bio.placeholder": "대화에서 쓸 나의 설정을 적어주세요",
  "profile.gender": "성별 (선택)",
  "profile.gender.female": "여성",
  "profile.gender.male": "남성",
  "profile.gender.none": "선택 안 함",
  "profile.default": "기본 프로필",
  "profile.default.description": "첫 프로필은 기본으로 설정돼요",
  "profile.edit.cta": "저장",
  "profile.cta": "저장하고 시작하기",
  "welcome.title": "웰컴 {amount}브릭 도착!",
  "welcome.body": "철벽을 허물 준비 됐나요?",
  "welcome.cta": "함락하러 가기",
  // F01-15 알림 권한 소프트 애스크(시안 91:3284, AC0-260). 미리보기 기본 대사는 시안 그대로(복귀할 캐릭터가 없을 때)
  "push.ask.title": "철벽남이 먼저\n연락할 수도 있어요",
  "push.ask.body": "알림을 켜 두면 그의 답장을 놓치지 않아요.\n언제든 설정에서 끌 수 있어요.",
  "push.ask.cta": "알림 받기",
  "push.ask.later": "나중에",
  "push.ask.appName": "함락",
  "push.ask.now": "· 지금",
  "push.ask.defaultName": "철벽남",
  "push.ask.defaultLine": "…오, 오늘은… 안 오세요?",
  "push.channel": "함락 알림",
  "settings.push": "푸시 알림",
  "settings.push.osDenied": "기기 설정에서 함락 알림을 허용해 주세요",

  // 마이페이지(1.16)
  "me.account.noName": "닉네임을 정해 주세요",
  "me.account.edit": "내 정보 편집",
  "me.account.photoAlt": "내 사진",
  "meEdit.photo.change": "사진 변경",
  "meEdit.photo.delete": "사진 삭제",
  "meEdit.photo.uploading": "업로드 중 {percent}%",
  "meEdit.photo.error": "사진을 올리지 못했어요. 다른 사진으로 시도해 주세요",
  "meEdit.nickname": "닉네임",
  "meEdit.save": "저장",
  "me.chatProfile.title": "대화 프로필",
  "me.chatProfile.edit": "대화 프로필 편집",
  "me.profile.default": "기본 채팅 프로필",
  "me.profile.defaultWithGender": "기본 채팅 프로필 · {gender}",
  "me.publicId": "회원번호",
  "me.publicId.copy": "회원번호 {id} 복사",
  "me.publicId.copied": "회원번호를 복사했어요",
  "me.id.copy": "ID {id} 복사",
  "me.id.copied": "ID를 복사했어요",
  "me.bricks.title": "보유 브릭",
  "me.bricks.charge": "충전하기",
  "me.section.payment": "결제",
  "me.section.etc": "기타",
  "me.menu.purchase": "결제 내역",
  "me.menu.usage": "브릭 사용 내역",
  "me.menu.coupon": "쿠폰 등록",
  "me.menu.settings": "설정",
  "me.loadError": "내 정보를 불러오지 못했어요",

  // 내역(1.17)
  "history.tab.purchase": "결제 내역",
  "history.tab.usage": "사용 내역",
  "history.refundNotice": "환불은 결제일로부터 {period} 이내 요청할 수 있어요.",
  "history.balance": "보유 브릭",
  // 스토어별 문구는 키 끝이 스토어 코드(google|apple|web) — 고르는 것은 codes.ts storeKey(내역은 거래의 meta.store, 그 외는 clientKind, ios.md i5)
  "history.status.paid.google": "Google Play · 결제 완료",
  "history.status.paid.apple": "App Store · 결제 완료",
  "history.status.refunded.google": "Google Play · 환불 완료",
  "history.status.refunded.apple": "App Store · 환불 완료",
  "history.status.paid.web": "웹 결제 · 결제 완료",
  "history.status.refunded.web": "웹 결제 · 환불 완료",
  "history.empty.purchase": "아직 결제 내역이 없어요",
  "history.empty.usage": "아직 사용 내역이 없어요",
  "history.loadError": "내역을 불러오지 못했어요",
  "history.more": "더 보기",
  "history.orderId": "주문번호 {orderId}",
  "history.expiresAt": "{date}까지",
  "history.refundableUntil": "{date}까지 환불 가능",
  "history.label.turn": "대화",
  "history.label.turnModel": "대화 · {model}",
  "history.label.suggestion": "추천 답변",
  "history.label.llm_failed": "대화 실패 환불",
  "history.label.suggestion_failed": "추천 답변 실패 환불",
  "history.label.reroll": "답변 다시 생성",
  "history.label.reroll_failed": "답변 다시 생성 실패 환불",
  "history.label.lot_expired": "무료 브릭 만료",
  "history.label.play_refund": "결제 환불 회수",
  "history.label.account_deleted": "탈퇴로 소멸",
  "history.label.welcome": "가입 축하 브릭",
  "history.label.purchase": "브릭 충전",
  "history.label.firstPurchase": "첫 결제 특가 ({bricks}브릭)",
  "history.label.manual": "운영 지급",
  "history.label.coupon": "쿠폰 지급",
  "history.label.bonus": "보너스 브릭 {bricks}개",
  "history.bonusNotice": "무료 보너스 · {date}까지 쓸 수 있고 환불되지 않아요",

  // 신고(1.21)
  "report.title": "신고하기",
  "report.description": "어떤 문제가 있나요?",
  "report.reason": "신고 사유",
  "report.detail": "자세한 내용 (선택)",
  "report.detail.placeholder": "신고 내용을 적어 주시면 검토에 도움이 돼요",
  "report.cta": "신고하기",
  "report.done": "신고가 접수됐어요. 24시간 안에 검토할게요.",
  "report.duplicate": "이미 신고한 메시지예요",
  "report.duplicatePlot": "이미 신고한 플롯이에요",
  "report.failed": "신고를 접수하지 못했어요",
  "report.noTarget": "신고할 메시지가 없어요",
  "report.target.last": "{name} · 마지막 응답",
  "report.target.selected": "{name} · 선택한 응답",
  "report.target.plot": "{name} · 플롯",
  // 신고 사유: settings.reportReasons 코드 → 문구. 모르는 코드는 숨김
  "report.reason.sexual": "선정적이거나 불쾌한 내용",
  "report.reason.violence": "폭력·혐오·차별 표현",
  "report.reason.minor": "미성년자를 연상시키는 내용",
  "report.reason.privacy": "개인정보·실존 인물 관련",
  "report.reason.off_character": "캐릭터 설정과 맞지 않는 응답",
  "report.reason.other": "기타",
  "chat.report": "신고",

  // 설정(1.18)
  "settings.section.notifications": "알림",
  "settings.marketing": "마케팅 정보 알림",
  "settings.nightMarketing": "야간 혜택 알림 (21시~08시)",
  // 수신 동의 처리 결과 통지(정보통신망법 50조, 시안 595:6547). 전송자 · 처리 일자 · 처리 내용
  "settings.consent.marketing.agreed": "함락 · {date} 마케팅 정보 수신에 동의했어요",
  "settings.consent.marketing.rejected": "함락 · {date} 마케팅 정보 수신을 거부했어요",
  "settings.consent.nightMarketing.agreed": "함락 · {date} 야간 혜택 알림 수신에 동의했어요",
  "settings.consent.nightMarketing.rejected": "함락 · {date} 야간 혜택 알림 수신을 거부했어요",
  "settings.section.general": "일반",
  "settings.section.info": "안내",
  "settings.defaultModel": "기본 대화 모델",
  "settings.defaultModel.saved": "기본 대화 모델을 바꿨어요",
  "settings.terms": "서비스 이용약관",
  "settings.privacy": "개인정보처리방침",
  "settings.operationPolicy": "운영정책",
  "settings.youthPolicy": "청소년 보호정책",
  "settings.refundPolicy": "환불정책",
  "settings.notice": "공지사항",
  "settings.support": "고객센터 문의",
  "settings.version": "버전 정보",
  "settings.login": "로그인",
  "settings.logout": "로그아웃",
  "settings.logout.title": "로그아웃할까요?",
  "settings.logout.body": "언제든 다시 로그인할 수 있어요.",
  "settings.logout.confirm": "로그아웃",
  "settings.delete": "회원 탈퇴",

  // 고객센터(1.19)
  "support.title": "무엇을 도와드릴까요?",
  "support.guide.form": "· 문의는 구글 폼으로 받아요. 버튼을 누르면 문의 양식이 열려요.",
  "support.guide.orderId.google": "· 결제·환불 문의는 구글 플레이 주문번호(GPA.로 시작)를 함께 적어 주세요.",
  "support.guide.orderId.apple": "· 결제·환불 문의는 App Store 영수증의 주문 번호(Order ID)를 함께 적어 주세요.",
  "support.guide.orderId.web": "· 결제·환불 문의는 결제 완료 화면의 주문번호를 함께 적어 주세요.",
  "support.guide.sla": "· 영업일 기준 1~2일 안에 답변드려요.",
  "support.ctaCaption": "구글 폼 문의 양식으로 연결돼요 (외부 브라우저)",
  "support.attached": "아래 정보가 문의에 자동으로 첨부돼요",
  "support.userId": "회원번호",
  "support.device": "기기",
  "support.os": "OS",
  "support.appVersion": "앱 버전",
  "support.guest": "비회원",
  "support.cta": "문의 남기기",

  // 탈퇴(1.20)
  "delete.notice.title": "탈퇴하기 전에\n아래 내용을 모두 확인해 주세요",
  "delete.bricks": "보유 {balance}브릭이 사라져요",
  "delete.bricks.body": "탈퇴하면 남은 브릭은 환불되지 않아요.",
  // 안내 고지 카드(F08-01 458:3748): 제목 + 설명(선택)
  "delete.notice.data": "개인 정보와 이용 정보는 즉시 삭제돼요",
  "delete.notice.data.body": "대화·채팅 프로필 등 모든 이용 내역이 삭제되고 복구할 수 없어요.\n단, 법령에 따라 보관해야 하는 정보(결제 기록 등)는 정해진 기간 동안 보관돼요.",
  "delete.notice.bricks": "보유 중인 모든 브릭이 소멸돼요",
  "delete.notice.bricks.body": "유료 브릭과 가입 선물 브릭 모두 사라지고 환불되지 않아요.",
  "delete.notice.refund": "남은 유료 브릭 환불은 탈퇴 전에 요청해 주세요",
  "delete.notice.refund.body": "결제 후 {period} 이내라면 고객센터로 환불을 요청할 수 있어요. 탈퇴 후에는 처리할 수 없어요.",
  "delete.notice.unrecoverable": "탈퇴한 계정 정보는 복구할 수 없어요",
  "delete.rejoin": "부정 이용 방지를 위해 {days}일 동안 다시 가입할 수 없어요",
  "delete.notice.restricted": "이용이 제한된 계정은 바로 탈퇴할 수 없어요",
  "delete.notice.restricted.body": "고객센터로 문의해 주세요.",
  "delete.notice.ack": "위 내용을 모두 확인했어요",
  "delete.reason.title": "떠나시는 이유를\n알려 주세요 (선택)",
  "delete.reason.description": "선택하지 않아도 탈퇴할 수 있어요. 남겨 주시면 더 나은 함락을 만드는 데 참고할게요.",
  "delete.reason.cta": "탈퇴하기",
  "delete.reason.detail": "자세한 내용 (선택)",
  "delete.reason.detail.placeholder": "더 나은 서비스를 위해 알려 주세요",
  // 탈퇴 사유: settings.deleteReasons 코드 → 문구. 모르는 코드는 숨김
  "delete.reason.character": "캐릭터가 마음에 들지 않아요",
  "delete.reason.chat_quality": "대화 품질이 아쉬워요",
  "delete.reason.expensive": "브릭 가격이 부담돼요",
  "delete.reason.other_service": "다른 서비스를 이용할래요",
  "delete.reason.not_used": "자주 사용하지 않아요",
  "delete.reason.other": "기타",
  "delete.confirm.title": "정말 탈퇴할까요?",
  "delete.confirm.body": "모든 대화와 보유 {balance}브릭이 즉시 삭제되고 복구할 수 없어요. 남은 브릭은 환불되지 않아요.",
  "delete.confirm.cta": "탈퇴",
  "delete.done.title": "탈퇴가 완료됐어요",
  "delete.done.body": "그동안 함락과 함께해 주셔서 고마워요.\n언제든 다시 기다리고 있을게요.",
  "delete.done.publicId": "결제 등 문의가 필요하면 회원번호 {id}를 알려 주세요.",
  "delete.done.cta": "처음으로",
  "delete.failed": "탈퇴를 처리하지 못했어요. 잠시 후 다시 시도해 주세요.",
  "delete.forbidden.pending": "가입을 마치지 않은 계정은 탈퇴할 필요가 없어요. 그대로 두면 자동으로 정리돼요.",

  // 상점(1.14) · 결제 완료(1.15)
  "store.history": "사용 내역 >",
  "store.balance.title": "보유 브릭",
  "store.firstPurchase.title": "첫 결제 특가 · 1회 한정",
  "store.firstPurchase.allRate": "모든 상품 {percent}% 할인",
  "store.firstPurchase.headline": "첫 결제 할인",
  "store.firstPurchase.half": "어떤 상품이든 첫 결제 한 번은 반값이에요",
  "store.firstPurchase.body": "첫 결제 한 번은 할인된 가격으로 살 수 있어요",
  "store.discountRate": "{percent}%",
  "store.bricks": "{bricks}브릭",
  "store.section.topup": "브릭 충전",
  "store.note.free": "가입 축하로 받은 브릭이 먼저 쓰이고, 받은 날부터 {days}일 뒤 사라져요",
  "store.note.refund": "결제 후 {period} 이내에는 환불을 요청할 수 있어요",
  "store.price": "₩{price}",
  "store.bonus": "+{bonus}",
  "store.pass.title": "함락 패스",
  "store.pass.body": "출시 예정이에요",
  "store.empty": "지금은 살 수 있는 상품이 없어요",
  "store.loadError": "상품을 불러오지 못했어요",
  "store.purchase.failed": "결제를 완료하지 못했어요",
  // F06-03(82:2824) 스토어 단계 실패 다이얼로그. 검증 단계 실패는 결제가 됐을 수 있어 스낵바(store.purchase.failed)로 둔다
  "store.purchase.failed.body": "결제가 취소되었거나 승인되지 않았어요.\n요금은 청구되지 않았어요.",
  "store.purchase.unavailable": "이 환경에서는 결제할 수 없어요",
  "store.purchase.preparing": "결제 준비 중이에요", // 웹 결제 연동 전 빌드(토스 클라이언트 키 없음, AC0-313)
  "store.web.confirming": "결제를 확인하고 있어요…",
  "store.web.confirmFailed": "결제 확인에 실패했어요. 결제가 됐다면 잠시 뒤 다시 시도하거나 고객센터에 문의해 주세요",
  "store.web.unsupported.title": "이 국가에서는 웹 결제를 지원하지 않아요",
  "store.web.unsupported.body": "계정 국가({country})에서는 아직 웹 결제를 열지 않았어요. 앱에서는 스토어 결제로 충전할 수 있어요. 지원을 원하시면 아래 버튼을 눌러 알려 주세요.",
  "store.web.unsupported.request": "결제 지원 요청",
  "store.web.unsupported.requested": "요청을 받았어요",
  "store.storeUnavailable": "스토어에 연결할 수 없어 지금은 결제할 수 없어요. 잠시 후 다시 시도해 주세요",
  "store.purchase.held": "결제는 확인됐지만 브릭 지급이 보류됐어요. 확인 후 넣어 드릴게요",
  "store.purchase.pending": "결제 승인을 기다리고 있어요. 승인되면 브릭이 들어와요",
  "store.purchase.recovered": "완료되지 않았던 결제의 브릭 {bricks}개를 넣어 드렸어요",
  "store.productUnknown": "상품 정보가 바뀌어 목록을 다시 불러와요",
  "store.done.title": "결제가 완료됐어요",
  "store.done.charged": "{bricks}브릭을 충전했어요",
  "store.done.sub": "이제 철벽을 허물러 가볼까요?",
  "store.done.alreadyGranted": "이미 지급된 결제예요",
  "store.done.balance": "보유 {balance}브릭",
  "store.done.product": "상품",
  "store.done.price": "결제 금액",
  "store.done.method": "결제 수단",
  "store.done.methodValue.google": "Google Play",
  "store.done.methodValue.apple": "App Store",
  "store.done.methodValue.web": "토스페이먼츠",
  "store.done.at": "일시",
  "store.done.cta": "확인",
  "store.done.ctaChat": "대화로 돌아가기",
  "store.done.continue": "상점 계속 보기",
  // 상품명·배지 문구(productId·badge 코드 → 문구)는 @hamlak/copy 로 이동 (어드민 미리보기와 공유)
  // 배지: badge 코드 → 문구. 모르는 코드는 표시하지 않는다. 첫 결제 특가는 배지가 아니라 할인율·원가(AC0-258)

  // 1회성 공지(1.22)
  "notice.refundRevoked.title": "환불된 결제가 있어요",
  // 시안 F06-14(346:1865). {store} = 결제 스토어 이름(payload.store), {price} = "(결제 금액)" 또는 빈 문자열
  "notice.refundRevoked.body": "{store}에서 환불된 결제{price}가 있어서, 그 결제로 받은 브릭을 회수하고 보유 브릭을 {balance}브릭으로 정리했어요.",
  "notice.refundRevoked.bodyNoStore": "환불된 결제{price}가 있어서, 그 결제로 받은 브릭을 회수하고 보유 브릭을 {balance}브릭으로 정리했어요.",
  "notice.refundRevoked.price": "({amount})",
  "notice.refundRevoked.store.google": "구글 플레이",
  "notice.refundRevoked.store.apple": "App Store",
  "notice.refundRevoked.store.web": "토스페이먼츠",
  // F06-15 이용 제한 안내창(382:1882). 두 문단은 \n 으로 나눈다
  "notice.blocked.body": "환불 후 브릭을 사용하는 이용이 반복되어, 운영정책에 따라 이 계정의 서비스 이용을 제한했어요.\n잘못된 조치라고 생각되면 고객센터로 알려 주세요.",

  "common.confirm": "확인",
  "common.cancel": "취소",
  "common.next": "다음",
  "common.close": "닫기",
  "common.retry": "다시 시도",
  "common.loading": "불러오는 중",
  "common.back": "뒤로",
  "error.generic": "문제가 생겼어요. 잠시 후 다시 시도해 주세요.",
  // F09-01(91:3343) 부트스트랩 실패 풀페이지
  "error.bootstrap.title": "연결이 끊겼어요",
  "error.bootstrap.body": "인터넷 연결을 확인하고 다시 시도해 주세요.\n대화 내용과 브릭은 안전하게 저장돼 있어요.",
  "error.NICKNAME_TAKEN": "이미 사용 중인 닉네임이에요",
  "error.NICKNAME_FORBIDDEN": "사용할 수 없는 닉네임이에요",
  "error.COUPON_NOT_FOUND": "존재하지 않는 쿠폰 코드예요",
  "error.COUPON_DISABLED": "사용할 수 없는 쿠폰이에요",
  "error.COUPON_NOT_STARTED": "아직 등록할 수 없는 쿠폰이에요",
  "error.COUPON_EXPIRED": "등록 기간이 지난 쿠폰이에요",
  "error.COUPON_ALREADY_REDEEMED": "이미 등록한 쿠폰이에요",
  "error.COUPON_EXHAUSTED": "모두 사용된 쿠폰이에요",
  "error.RATE_LIMITED": "잠시 후 다시 시도해 주세요",
  "coupon.label": "쿠폰 코드",
  "coupon.submit": "등록하기",
  "coupon.toast": "{amount}브릭이 들어왔어요",
  "coupon.placeholder": "쿠폰 코드를 입력해 주세요",
  "coupon.notice.1": "쿠폰으로 받은 브릭은 환불되지 않아요.",
  "coupon.notice.2": "등록한 날부터 30일 동안 쓸 수 있어요.",
  "coupon.notice.3": "쿠폰은 계정당 한 번만 등록할 수 있어요.",
  "nickname.invalid": "2~16자의 한글·영문·숫자만 쓸 수 있어요",
  "error.network": "네트워크 연결을 확인해 주세요.",
  "error.settings": "앱 정보를 불러오지 못했어요.",
  // F09-02(91:3366) 강제 업데이트 · F09-03(91:3385) 서비스 점검 풀페이지. 점검 제목·본문은 운영 설정(maintenance.title·message)이 우선
  "blocked.update.title": "새 버전이 나왔어요",
  "blocked.update.body": "더 깊어진 함락을 위해 업데이트가 필요해요.\n업데이트 후 계속 이용할 수 있어요.",
  "blocked.update.cta": "업데이트하기",
  "blocked.maintenance.title": "잠시 점검 중이에요",
  "blocked.maintenance.body": "더 단단한 철벽으로 돌아올게요.",
  "blocked.maintenance.cta": "공지 보기",
  "blocked.account": "계정 이용이 제한됐어요.",
  "blocked.account.title": "계정 이용이 제한됐어요",
  "blocked.account.body": "자세한 내용은 고객센터로 문의해 주세요.",
  "blocked.account.cta": "확인",
  "blocked.account.support": "고객센터 문의",
  "page.placeholder": "준비 중인 화면이에요",
  "page.plot": "플롯",
  "page.chat": "채팅",
  "page.login": "로그인",
  "page.terms": "약관 동의",
  "page.birthDate": "생년월일 확인",
  "page.profileNew": "내 채팅 프로필",
  "page.profileEdit": "대화 프로필",
  "page.store": "브릭 상점",
  "page.storeDone": "결제 완료",
  "page.chats": "대화",
  "page.me": "마이페이지",
  "page.meEdit": "내 정보 편집",
  "page.coupon": "쿠폰 입력",
  "page.bricks": "브릭 내역",
  "page.settings": "설정",
  "page.support": "고객센터",
  "page.delete": "회원 탈퇴",
  "page.go": "이동 중",
  "go.installPrompt": "앱을 설치하면 이 캐릭터로 바로 이어져요",
  "go.openPlay": "Google Play에서 설치",
  "period.days": "{n}일",
  "period.years": "{n}년",
} as const;

export type MessageKey = keyof typeof ko;

/** `t('login.sheet.description', { welcome: 1000 })` — `{name}` 자리에 값을 끼운다. */
/**
 * 받침 유무로 조사 선택: withJosa("김흰", "과", "와") → "과", withJosa("플레이스홀더", "과", "와") → "와".
 * 숫자는 한글 읽기 기준(0·1·3·6·7·8 받침 있음), 그 외 비한글(영문 등)은 받침 없음으로 본다.
 */
export function withJosa(word: string, withFinal: string, withoutFinal: string): string {
  const last = word.trimEnd().slice(-1);
  if (/[013678]/.test(last)) return withFinal;
  const code = last.charCodeAt(0);
  if (code < 0xac00 || code > 0xd7a3) return withoutFinal;
  return (code - 0xac00) % 28 === 0 ? withoutFinal : withFinal;
}

/** 일수 → 기간 문구: 365의 배수면 "1년"·"2년", 아니면 "7일" (환불 기간 등 pricing 일수 표시) */
export function periodText(days: number): string {
  return days > 0 && days % 365 === 0 ? t("period.years", { n: days / 365 }) : t("period.days", { n: days });
}

export function t(key: MessageKey, vars?: Record<string, string | number>): string {
  const template: string = ko[key];
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (_, name: string) => {
    const v = vars[name];
    return v === undefined ? `{${name}}` : typeof v === "number" ? v.toLocaleString("ko-KR") : v;
  });
}
